import {Avatar, Layout} from 'antd'
import {userModel} from 'apis/model'
import {LoginContext} from 'components/LoginContext'
import {UseHook} from 'components/UseReducer'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import useOnLocationChange from 'modules/navigation/useOnLocationChange'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useRef} from 'react'
import {MdClose} from 'react-icons/md'
import {useClickAway, useToggle} from 'react-use'
import {staticPaths} from 'routes/staticPaths'
import UserCtrl from 'views/NewFeed/UserCtrl.lazy'
import {LayoutContext} from './LayoutContext'
import {RiUser2Fill} from "react-icons/ri";


const {Sider} = Layout

const User = () => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const history = useHistory()
    const [isToggle, toggle] = useToggle()

    if (!login)
        return (
            <div
                onClick={() => history.push(staticPaths.login)}
                style={{ width: 50, height: 50, borderRadius: 999, cursor:'pointer' }}
                className="flex flex-center background-200 hover:bg-secondary-50 border hover:border-secondary-600 text-color-400 hover:text-secondary-600">
                <RiUser2Fill size={24}/>
            </div>
        )

    return (
        <React.Fragment>
            <Avatar
                onClick={() => toggle(true)}
                size={50}
                className={
                    !isToggle
                        ? 'background-200 border border-color-50 hover:border-color-100'
                        : 'background-200 no-border pointer-events-none'
                }
                src={userModel.getFullAvatarUrl(login)}>
                <div className="font-bold text-xl text-color-300 uppercase">
                    {_.first(userModel.getTitle(login))}
                </div>
            </Avatar>
            {isToggle && (
                <UseHook hook={useRef}>
                    {(ref) => (
                        <>
                            <UseHook deps={[toggle]} hook={useOnLocationChange}/>
                            <div style={{left: 60, background: '#000', opacity: 0.5}}
                                 className="w-full h-full fixed top-0 left-0"/>
                            <div
                                ref={ref}
                                style={{
                                    width: 350,
                                    position: 'absolute',
                                    height: '100vh',
                                    bottom: 0,
                                    left: 60,
                                }}
                                className="background relative">
                                <UserCtrl
                                    useClickAway={
                                        <UseHook
                                            hook={useClickAway}
                                            deps={[ref, toggle]}/>
                                    }
                                />
                                <MdClose
                                    onClick={() => toggle()}
                                    className="absolute top-10 right-10 text-white opacity-50 hover:opacity-100 z-10"
                                />
                            </div>
                        </>
                    )}
                </UseHook>
            )}
        </React.Fragment>
    )
}

export const LeftSider = () => {
    return (
        <LayoutContext.Consumer>
            {({leftSideBarWidth, collapsedMenuWidth, leftInner}) => {
                return (
                    <Sider
                        className="z-50 background"
                        theme="light"
                        collapsed={true}
                        collapsible
                        trigger={null}
                        width={leftSideBarWidth}
                        collapsedWidth={collapsedMenuWidth}>
                        <div
                            className="flex flex-col justify-between"
                            style={{
                                width: 60,
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                height: '100vh',
                            }}>
                            <div className="flex flex-1">
                                {leftInner}
                            </div>
                            <div
                                className="mt-1 p-1 flex flex-center border-t border-color-50 cursor-pointer"
                                style={{ width: 60, height: 60 }}>
                                <User/>
                            </div>
                        </div>
                    </Sider>
                )
            }}
        </LayoutContext.Consumer>
    )
}
